import { render } from "./volume-off.vue?vue&type=template&id=44712bb4"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/volume-off.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44712bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44712bb4', __exports__)) {
    api.reload('44712bb4', __exports__)
  }
  
  module.hot.accept("./volume-off.vue?vue&type=template&id=44712bb4", () => {
    api.rerender('44712bb4', render)
  })

}


export default __exports__